/**
 * Flattens pasted plain text into a single line: every line break becomes a space.
 */
export function flattenPastedText(text: string): string {
  return text.replace(/\s*\n\s*/g, ' ')
}

/**
 * Flattens pasted HTML into a single line: block boundaries and line breaks become spaces,
 * block tags are dropped, inline nodes (such as variable chips) are kept as is.
 */
export function flattenPastedHtml(html: string): string {
  return flattenPastedText(
    html
      .replace(/<\/(p|div|li|h[1-6]|tr|td|th)>|<br\s*\/?>/gi, ' ')
      .replace(
        /<\/?(p|div|li|ul|ol|h[1-6]|table|tbody|thead|tr|td|th|blockquote)(\s[^>]*)?>/gi,
        ''
      )
  )
}
